"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChecklistIndicator = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const lib_1 = require("../../lib");
const Icon_1 = require("../Icon");
const ChecklistIndicator = ({ completed, number, style = 'success', className }) => {
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, lib_1.classnames)((0, lib_1.bem)('checklist-indicator', `--style-${style}`, (0, lib_1.use)(completed, '--success')), className) }, { children: completed ? (0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: "check" }, void 0) : number }), void 0));
};
exports.ChecklistIndicator = ChecklistIndicator;
//# sourceMappingURL=ChecklistIndicator.js.map